/**
 * US phone mask — formats input as `(XXX) XXX-XXXX`, stripping non-digits and capping at 10
 * digits. Shared by every phone input so the mask stays consistent across the app.
 */
export function formatPhone(value: string): string {
  const digits = value.replace(/\D/g, '').slice(0, 10);
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}
